// extracted by mini-css-extract-plugin
export default {"preview-area__basic-info":"ContactinfoPreview_preview-area__basic-info__j7hEi"};